import { StrictMode } from "react"

import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
import angular from "angular"

import { queryClient } from "@/query/queryClient"

import { StudentHelperStudentInfoModal } from "./StudentHelperStudentInfoModal"

interface IStudentHelperStudentInfoModalScope extends angular.IScope {
  onClose: () => void
}

export function StudentHelperStudentInfoModalDirective(): angular.IDirective {
  return {
    restrict: "E",
    scope: {
      onClose: "&",
    },
    link: function (
      scope: IStudentHelperStudentInfoModalScope,
      element: angular.IAugmentedJQuery,
    ) {
      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <StudentHelperStudentInfoModal
              isOpen={true}
              onClose={() => {
                scope.$apply(() => {
                  scope.onClose()
                })
              }}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any as angular.IDirective
}
